<template>
    <div class="customer-management">
        <!-- 搜索和操作区 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="客户名称">
                    <el-input v-model="searchForm.name" placeholder="请输入客户名称" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="searchCustomers" icon="el-icon-search">
                        搜索
                    </el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">
                        重置
                    </el-button>
                    <el-button type="success" @click="showAddDialog" icon="el-icon-plus">
                        新增客户
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 客户列表 -->
        <el-card class="main-content">
            <el-table ref="customerTable" :data="pagedCustomers" border stripe
                :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleRowClick"
                height="calc(100vh - 300px)">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
                <el-table-column prop="customerCode" label="客户编码" align="center"></el-table-column>
                <el-table-column prop="customerName" label="客户名称" width="100" align="center"></el-table-column>
                <el-table-column prop="customerPhone" label="联系电话" width="120" align="center"></el-table-column>
                <el-table-column prop="customerType" label="客户类型" align="center">
                    <template #default="scope">
                        {{ formatCustomerType(scope.row.customerType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="organization" label="客户组织机构" align="center"></el-table-column>
                <el-table-column prop="customerAddress" label="地址" align="center"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template #default="scope">
                        <el-button type="primary" size="small" icon="el-icon-view" @click="showDetailDialog(scope.row)">
                            详情
                        </el-button>
                        <!--  <el-button type="text" @click="showEditDialog(scope.row)">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" class="text-danger" @click="deleteCustomer(scope.row.id)">
                            删除
                        </el-button> -->

                        <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row)"
                            size="small">修改</el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="deleteCustomer(scope.row.id)"
                            size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
                :total="filteredCustomers.length" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>

        <!-- 新增/编辑客户弹窗 -->
        <el-dialog :title="isEditMode ? '编辑客户' : '新增客户'" :visible.sync="formVisible" width="800px"
            :close-on-click-modal="false" :z-index="3000" append-to-body>
            <div class="step-content">
                <el-form :model="customerForm" :rules="basicRules" ref="basicForm" label-width="120px"
                    class="form-container">
                    <!-- <el-form-item label="客户编码" prop="customerCode">
                        <el-input v-model="customerForm.customerCode" readonly placeholder="自动生成"></el-input>
                    </el-form-item> -->
                    <el-form-item label="客户名称" prop="customerName">
                        <el-input v-model="customerForm.customerName" placeholder="请输入客户名称"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="customerPhone">
                        <el-input v-model="customerForm.customerPhone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="客户组织机构" prop="organization">
                        <el-input v-model="customerForm.organization" placeholder="请输入客户组织机构"></el-input>
                    </el-form-item>
                    <el-form-item label="客户地址" prop="customerAddress">
                        <el-input v-model="customerForm.customerAddress" placeholder="请输入客户地址"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="customerForm.remark" placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item label="客户类型" prop="customerType">
                        <el-select v-model="customerForm.customerType" placeholder="请选择客户类型">
                            <el-option label="网站注册" value="0"></el-option>
                            <el-option label="线下推广" value="1"></el-option>
                            <el-option label="客户推荐" value="2"></el-option>

                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取消</el-button>
                <el-button type="success" @click="saveCustomer">保存</el-button>
            </div>
        </el-dialog>

        <!-- 客户详情弹窗 -->
        <el-dialog title="客户详情" :visible.sync="detailVisible" width="800px" :close-on-click-modal="false"
            append-to-body>
            <el-descriptions column="1" border class="detail-descriptions">
                <el-descriptions-item label="客户编码">{{
                    detailData.customerCode
                }}</el-descriptions-item>
                <el-descriptions-item label="客户名称">{{
                    detailData.customerName
                }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{
                    detailData.customerPhone
                }}</el-descriptions-item>
                <el-descriptions-item label="客户类型">{{
                    formatCustomerType(detailData.customerType)
                }}</el-descriptions-item>
                <el-descriptions-item label="客户组织机构">{{
                    detailData.organization
                }}</el-descriptions-item>
                <el-descriptions-item label="客户地址">{{
                    detailData.customerAddress
                }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{
                    detailData.remark || "无"
                }}</el-descriptions-item>
            </el-descriptions>
            <div slot="footer">
                <el-button @click="detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { delCustomer, getCustomerList, edit, add } from "@/api/customer";

export default {
    name: "CustomerManagement",
    data() {
        return {
            // 搜索表单
            searchForm: {
                name: "",
                orderNo: "",
            },

            // 客户数据
            customers: [], // 原始数据
            filteredCustomers: [], // 筛选后的数据

            // 分页参数
            currentPage: 1,
            pageSize: 10,

            // 弹窗状态
            formVisible: false, // 新增/编辑弹窗
            detailVisible: false, // 详情弹窗
            isEditMode: false, // 是否为编辑模式

            // 表单数据
            customerForm: {
                id: "",
                customerCode: "",
                customerName: "",
                customerPhone: "",
                organization: "",
                customerAddress: "",
                remark: "",
                customerType: "",
                userId: "", // 关联用户ID
            },

            // 详情数据
            detailData: {},

            // 表单验证规则
            basicRules: {
                customerName: [
                    { required: true, message: "请输入客户名称", trigger: "blur" },
                ],
                customerPhone: [
                    { required: true, message: "请输入联系电话", trigger: "blur" },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur",
                    },
                ],
                customerType: [
                    { required: true, message: "请选择客户类型", trigger: "change" },
                ],
            },
        };
    },

    computed: {
        // 分页处理后的数据
        pagedCustomers() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredCustomers.slice(start, end);
        },
    },

    created() {
        this.initCustomerList();
    },

    methods: {
        // 1. 初始化客户列表（带userId）
        async initCustomerList() {
            try {
                const userId = localStorage.getItem("userId");
                if (!userId) {
                    this.$message.error("用户未登录，请重新登录");
                    return;
                }

                // 调用列表接口，传入userId
                const res = await getCustomerList({ userId });
                if (res.code === 200) {
                    this.customers = res.data || [];
                    this.filteredCustomers = [...this.customers]; // 初始化筛选数据
                } else {
                    this.$message.error(`获取数据失败：${res.message}`);
                }
            } catch (err) {
                console.error("获取客户列表异常：", err);
                this.$message.error("网络错误，获取数据失败");
            }
        },

        // 2. 搜索客户
        searchCustomers() {
            this.currentPage = 1; // 重置页码
            this.filteredCustomers = this.customers.filter((customer) => {
                // 客户名称筛选
                const nameMatch = this.searchForm.name
                    ? customer.customerName.includes(this.searchForm.name)
                    : true;
                // 订单编号筛选（假设客户有orders字段）
                const orderMatch = this.searchForm.orderNo
                    ? customer.orders?.some((order) =>
                        order.orderNo.includes(this.searchForm.orderNo)
                    )
                    : true;
                return nameMatch && orderMatch;
            });
        },

        // 3. 重置搜索
        resetSearch() {
            this.searchForm = { name: "", orderNo: "" };
            this.currentPage = 1;
            this.filteredCustomers = [...this.customers]; // 恢复原始数据
        },

        // 4. 新增客户弹窗
        showAddDialog() {
            this.isEditMode = false;
            this.formVisible = true;
            const userId = localStorage.getItem("userId");

            // 生成客户编码（示例：C + 时间戳后6位）
            // const timestamp = Date.now().toString().slice(-6);
            this.customerForm = {

                customerName: "",
                customerPhone: "",
                organization: "",
                customerAddress: "",
                remark: "",
                customerType: "",
                userId: userId, // 绑定当前用户ID
            };

            // 重置表单验证
            this.$nextTick(() => {
                this.$refs.basicForm.resetFields();
            });
        },

        // 5. 编辑客户弹窗
        showEditDialog(customer) {
            this.isEditMode = true;
            this.formVisible = true;
            const userId = localStorage.getItem("userId");

            // 复制客户数据并绑定userId
            this.customerForm = {
                ...customer,
                userId: userId, // 确保编辑时携带userId
            };

            // 重置表单验证
            this.$nextTick(() => {
                this.$refs.basicForm.resetFields();
            });
        },

        // 6. 查看客户详情
        showDetailDialog(customer) {
            this.detailVisible = true;
            this.detailData = { ...customer };
        },

        // 7. 保存客户（新增/编辑）
        async saveCustomer() {
            this.$refs.basicForm.validate(async (valid) => {
                if (!valid) return;

                try {
                    const userId = localStorage.getItem("userId");
                    if (!userId) {
                        this.$message.error("用户未登录，请重新登录");
                        return;
                    }

                    // 确保userId存在
                    this.customerForm.userId = userId;

                    let res;
                    if (this.isEditMode) {
                        // 编辑：调用edit接口
                        res = await edit(this.customerForm);
                    } else {
                        // 新增：调用add接口
                        res = await add(this.customerForm);
                    }

                    if (res.code === 200) {
                        this.$message.success(
                            this.isEditMode ? "编辑成功" : "新增成功"
                        );
                        this.formVisible = false;
                        this.initCustomerList(); // 重新加载列表
                    } else {
                        this.$message.error(`操作失败：${res.message}`);
                    }
                } catch (err) {
                    console.error("保存客户异常：", err);
                    this.$message.error("网络错误，操作失败");
                }
            });
        },

        // 8. 删除客户
        async deleteCustomer(id) {
            this.$confirm("确定删除该客户吗？删除后不可恢复", "确认删除", {
                type: "warning",
            })
                .then(async () => {
                    try {
                        const res = await delCustomer({ id });
                        if (res.code === 200) {
                            this.$message.success("删除成功");
                            this.initCustomerList(); // 重新加载列表
                        } else {
                            this.$message.error(`删除失败：${res.message}`);
                        }
                    } catch (err) {
                        console.error("删除客户异常：", err);
                        this.$message.error("网络错误，删除失败");
                    }
                })
                .catch(() => {
                    // 取消删除
                });
        },

        // 9. 格式化客户类型
        formatCustomerType(type) {
            const typeMap = {
                0: "网站注册",
                1: "线下推广",
                2: "客户推荐",
                social: "社交媒体",
                other: "其他渠道",
            };
            return typeMap[type] || type;
        },

        // 10. 分页相关
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 重置页码
        },
        handleCurrentChange(page) {
            this.currentPage = page;
        },

        // 11. 表格行点击（选中/取消选中）
        handleRowClick(row) {
            this.$refs.customerTable.toggleRowSelection(row);
        },
    },
};
</script>

<style lang="scss" scoped>
.customer-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 搜索区样式 */
.search-card {
    margin-bottom: 20px;

    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        padding: 10px 0;
    }
}

/* 列表区样式 */
.main-content {
    margin-bottom: 15px;
}

/* 分页样式 */
.pagination-container {
    text-align: right;
    margin-top: 10px;
}

/* 详情弹窗样式 */
.detail-descriptions {
    margin-top: 10px;

    .el-descriptions-item__label {
        font-weight: 500;
        background-color: #f9fafb;
    }
}

/* 通用样式 */
.text-danger {
    color: #ff4d4f;
}

.form-container {
    padding: 10px 0;
}
</style>